import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const MIN_MAX_AGE: number = 5 * 1000;

const RESOURCE_TYPE_FILTERS_DIRECTORY = 'FILTERS_DIRECTORY';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const filtersDirectoryResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_FILTERS_DIRECTORY,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-filters-directory", jiraSpaEntry: "async-resource-filters-directory" */ './getData.tsx'
		),
	maxAge: MIN_MAX_AGE,
});
